const tree = {
  state: {
    treeModel: []
  },
  mutations: {
    /**组件勾选后会触发*/
    refreshData: (state, newArray) => {
      state.treeModel = newArray
    }
  },
}

export default tree
